import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Moment } from 'moment';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-booking-window-close',
    templateUrl: './editor-booking-item-setting-field-booking-window-close.component.html',
    styleUrls: ['./editor-booking-item-setting-field-booking-window-close.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldBookingWindowCloseComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  hourNames: { id: number, name: string }[];
  minuteNames: { id: number, name: string }[];
  startAt: Moment;

  constructor(private editorData: EditorDataService) {
    this.hourNames = this.editorData.hourNames;
    this.minuteNames = this.editorData.minuteNames;
  }

  ngOnInit() {
    this.parentFormGroup.controls['openDate'].valueChanges
      .pipe(
        filter(value => value !== null),
        takeUntil(this.destroyed$)
      )
      .subscribe(value => {
        if (this.parentFormGroup.controls['closeDate'].value === null) {
          this.startAt = value;
        }
      });

    this.parentFormGroup.controls['closeDate'].valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(value => this.startAt = value === null ? this.parentFormGroup.controls['openDate'].value : value);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
